export default {"src":"/_next/static/media/brand-selected-clock.62cdd546.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};